// extracted by mini-css-extract-plugin
export default {"header__container":"UserRegistrationNavbar_header__container__CB2iS","header__logo-box":"UserRegistrationNavbar_header__logo-box__Y5rjd"};